export default {
  pageTitle: 'Other Equipment Fabrication',
  metaDescription: 'TEF fabricates screw conveyors, agitators, impellers and other specialized industrial equipment in duplex stainless steel and exotic alloys.',
  sidebar: {
    title: 'Fabrication list',
    vessel: 'Fabrication Vessel',
    heatExchanger: 'Fabrication Heat Exchanger',
    piping: 'Fabrication Piping',
    tower: 'Fabrication Tower',
    muffle: 'Fabrication Muffle',
    radiantTube: 'Fabrication Radiant Tube',
    otherEquipment: 'Fabrication Other Equipment',
  },
  fabricationOf: 'Fabrication of',
  product: {
    name: 'Other Equipment',
    desc: 'The following is a catalog of our experience in Other Equipment fabrication in various types of materials, types and specifications.',
  },
};
